import React, { useEffect, useState } from 'react';
import { Box, Avatar, Typography, Paper } from '@mui/material';
import { unit } from '../../../components/Apis';
import Sidebarlayout from './sidebarlayout';
import Sidebaravailability from './sidebaravailability';

import { useParams } from "react-router-dom";

const Unit = ({ unitId }) => {
  const [userData, setUserData] = useState(null);
  const [selectedButton, setSelectedButton] = useState('PropertyDetails');
  const { id } = useParams(); // اجلب معرف الوحدة من المسار

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return { color: "green", label: "✔ Approved" };
      case "pending":
        return { color: "orange", label: "⏳ Pending" };
      case "canceled":
        return { color: "red", label: "✖ Canceled" };
      default:
        return { color: "black", label: status };
    }
  };
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await unit(unitId);
        setUserData(response);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [id]);

  if (!userData) {
    return <div>Loading...</div>;
  }


  const containerStyle = {
    display: 'flex',
    flexDirection: 'row', // ترتيب الأزرار جنب بعض
    alignItems: 'center', // محاذاة الأزرار بشكل مركزي
    padding: '20px', // مسافة داخلية للحاوية
    borderRadius: '20px', // حواف خلفية دائرية
    backgroundColor: '#C47D601F', // لون الخلفية
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // ظل للخلفية
  };

  const buttonStyle = (isSelected) => ({
    display: 'inline-block',
    padding: '10px 40px', // حجم الزر
    backgroundColor: isSelected ? 'var(--pri-col)' : 'transparent', // لون عند التحديد وغير التحديد
    color: isSelected ? 'white' : 'var(--pri-col)',
    borderRadius: '15px', // حواف دائرية
    fontFamily: 'Arial, sans-serif',
    fontSize: '16px',
    textAlign: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    border: 'none', // إزالة الإطار
    margin: '0 10px', // مسافة بين الأزرار
    transition: 'background-color 0.2s, transform 0.2s',
  });

  const handleClick = (button) => {
    setSelectedButton(button);
  };
  return (
    <Box dir="ltr">
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 2,
          maxWidth: "90%",
          margin: '0 auto',
        }}
      >

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexWrap:"wrap",
            justifyContent: 'space-between',
            borderRadius: 2,
            p: 2,
          }}
        >
          {/* Profile Section */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar
              src={userData.owner_image}
              alt={userData.name}
              sx={{ width: 80, height: 80 }}
            />
            <Box>
              <Typography
                variant="body2"
                sx={{ color: 'gray', fontSize: '14px', textAlign: 'center' }}
              >
                Owner Name
              </Typography>
              <Typography 
              // variant="h6" 
              sx={{ fontWeight: 'bold',fontSize:"12px"}}>
                {userData.owner_name}
              </Typography>

            </Box>
          </Box>



          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

            <Box>
              <Typography
                variant="body2"
                sx={{ color: 'gray', fontSize: '14px',textAlign:'center'}}
              >
                Name
              </Typography>
              <Typography 
              // variant="h6" 
              sx={{ fontWeight: 'bold',fontSize:"12px"}}>
                {userData.name}
              </Typography>

            </Box>
          </Box>

          <Box>
            <Typography
              variant="body2"
              sx={{ color: 'gray',textAlign: 'center'}}
            >
              Traveler Name
            </Typography>
            <Typography 
            // variant="body1" 
            sx={{ fontWeight: 'bold',fontSize:"12px" ,textAlign: 'center' }}>
              {userData.traveler_name ? userData.traveler_name : "N/A"}
            </Typography>
          </Box>

          {/* Email Section */}
          <Box>
            <Typography
              variant="body2"
              sx={{ color: 'gray', textAlign: 'center' }}
            >
              Number Of Bookings
            </Typography>
            <Typography 
            // variant="body1" 
            sx={{ fontWeight: 'bold',fontSize:"12px" ,textAlign: 'center'}}>
              {userData.number_of_bookings}
            </Typography>
          </Box>

          {/* Mobile Number Section */}
          <Box>
            <Typography
              variant="body2"
              sx={{ color: 'gray', textAlign: 'center' }}
            >
              Creation date
            </Typography>
            <Typography 
            // variant="body1" 
            sx={{ fontWeight: 'bold',fontSize:"12px" }}
            >
              {userData.created_at}
            </Typography>
          </Box>



          <Box>
            <Typography
              variant="body2"
              sx={{ color: 'gray', textAlign: 'center' }}
            >
              Status
            </Typography>
            <Typography
              // variant="body1"
              sx={{
                fontWeight: 'bold', fontSize:"12px",
                color: (theme) => getStatusColor(userData.status).color, // Dynamically set color
              }}
            >
              {getStatusColor(userData.status).label}
            </Typography>
          </Box>
        </Box>
      </Paper>


      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          height: '20vh',
          padding: '20px',
        }}
      >
        <div style={containerStyle}>



          <div
            style={buttonStyle(selectedButton === 'PropertyDetails')}
            onClick={() => handleClick('PropertyDetails')}
          >
            Property Details
          </div>





          <div
            style={buttonStyle(selectedButton === 'Availability')}
            onClick={() => handleClick('Availability')}
          >
            Availability

          </div>
        </div>
      </div>
      {selectedButton === "PropertyDetails" && (
        <>
          <Sidebarlayout unit={userData} />
        </>
      )}


      {selectedButton === "Availability" && (
        <>
          <Sidebaravailability unit={userData} />
        </>
      )}
    </Box>
  )
}

export default Unit